
<mdb-form-control class="form-fill datepicker">
    <input
        mdbInput
      [mdbDatepicker]="datepicker"
      type="text"
      class="form-control"
      id="exampleDatepicker"
      (click)="datepicker.open()"
      #datepickerChips
    />
    <label mdbLabel for="exampleDatepicker" class="form-label form-label-datapicker-chips">Choose a date</label>
    <mdb-datepicker #datepicker="mdbDatepicker" [format]="'mmmm dd, yyyy'" (dateChanged)="onDateChange()"></mdb-datepicker>
  </mdb-form-control>

  <div class="chips-list">   
    <div *ngFor="let item of list; let i = index" class="chips-item">  
      <span> {{item}} </span>
      <app-icon-delete-chips (click)="dropOption(i)"></app-icon-delete-chips>
    </div> 
</div>    
